import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as constants from '~/constant';

// W-0743 — Filtros. Fonte: UAtuCadPref.dfm/.pas. Órgão define coluna/título; Água tem sub-filtro (rótulos×lógica invertidos — ver MEMORY).
const setField = (setFiltros, campo, valor) =>
  setFiltros((prev) => ({ ...prev, [campo]: valor }));

const Filtros = ({
  filtros,
  setFiltros,
  gesOptions,
  geSelecionado,
  onChangeGe,
  empresas,
  empresaSelecionada,
  onChangeEmpresa,
  empreendimentos,
  empreendimentoSelecionado,
  onChangeEmpreendimento,
}) => {
  const inputDateStyle = { fontSize: '0.875rem', height: '31px', padding: '2px 8px' };

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', fontWeight: 'bold' }}>
        Filtros
      </Card.Header>
      <Card.Body className="py-2">
        {/* GE / Empresa / Empreendimento */}
        <Row className="mb-2">
          <Col md={4}>
            <Form.Label className="font-weight-bold mb-1">GE</Form.Label>
            <Select
              placeholder="Selecione o GE..."
              options={gesOptions}
              value={geSelecionado}
              onChange={onChangeGe}
              styles={customStyles}
              components={{ DropdownIndicator }}
              noOptionsMessage={() => 'Nenhum GE disponível'}
            />
          </Col>
          <Col md={4}>
            <Form.Label className="font-weight-bold mb-1">Empresa</Form.Label>
            <Select
              placeholder="Todas as empresas"
              options={empresas}
              value={empresaSelecionada}
              onChange={onChangeEmpresa}
              styles={customStyles}
              components={{ DropdownIndicator }}
              isClearable
              isDisabled={!geSelecionado}
              noOptionsMessage={() => 'Selecione um GE primeiro'}
            />
          </Col>
          <Col md={4}>
            <Form.Label className="font-weight-bold mb-1">Empreendimento</Form.Label>
            <Select
              placeholder="Todos os empreendimentos"
              options={empreendimentos}
              value={empreendimentoSelecionado}
              onChange={onChangeEmpreendimento}
              styles={customStyles}
              components={{ DropdownIndicator }}
              isClearable
              isDisabled={!geSelecionado}
              noOptionsMessage={() => 'Selecione um GE primeiro'}
            />
          </Col>
        </Row>

        {/* Datas + Órgão */}
        <Row className="mb-2">
          <Col md={3}>
            <Form.Label className="font-weight-bold mb-1">Data Inicial</Form.Label>
            <MaskedInput
              mask={constants.MASK_DATE}
              className="form-control"
              style={inputDateStyle}
              placeholder="dd/mm/aaaa"
              value={filtros.dataInicial}
              onChange={(e) => setField(setFiltros, 'dataInicial', e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Label className="font-weight-bold mb-1">Data Final</Form.Label>
            <MaskedInput
              mask={constants.MASK_DATE}
              className="form-control"
              style={inputDateStyle}
              placeholder="dd/mm/aaaa"
              value={filtros.dataFinal}
              onChange={(e) => setField(setFiltros, 'dataFinal', e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Label className="font-weight-bold mb-1">Órgão</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Prefeitura"
                id="radio-orgao-pref"
                name="orgao"
                checked={filtros.orgao === 'P'}
                onChange={() => setField(setFiltros, 'orgao', 'P')}
              />
              <Form.Check
                inline
                type="radio"
                label="Água"
                id="radio-orgao-agua"
                name="orgao"
                checked={filtros.orgao === 'A'}
                onChange={() => setField(setFiltros, 'orgao', 'A')}
              />
            </div>
          </Col>
          {filtros.orgao === 'A' && (
            <Col md={3}>
              <Form.Label className="font-weight-bold mb-1">Filtro Água</Form.Label>
              <Form.Control
                as="select"
                size="sm"
                value={filtros.filtroAgua}
                onChange={(e) => setField(setFiltros, 'filtroAgua', e.target.value)}
              >
                <option value="COM">Com Água</option>
                <option value="SEM">Sem Água</option>
                <option value="AMBOS">Ambos</option>
              </Form.Control>
            </Col>
          )}
        </Row>

        {/* Checkboxes */}
        <Row className="mb-1">
          <Col md={4}>
            <Form.Check
              type="checkbox"
              id="chk-lavra"
              label="Não considerar lotes com escritura lavrada"
              checked={filtros.naoConsideraEscrituraLavrada}
              onChange={(e) => setField(setFiltros, 'naoConsideraEscrituraLavrada', e.target.checked)}
            />
          </Col>
          <Col md={4}>
            <Form.Check
              type="checkbox"
              id="chk-ultima"
              label="Listar apenas última venda/transferência"
              checked={filtros.apenasUltimaVenda}
              onChange={(e) => {
                const checked = e.target.checked;
                // R4 — última venda oculta e desmarca cedente. Fonte: pas:1659-1667.
                setFiltros((prev) => ({
                  ...prev,
                  apenasUltimaVenda: checked,
                  listarCedente: checked ? false : prev.listarCedente,
                }));
              }}
            />
          </Col>
          {/* R4 — cedente só aparece quando NÃO é "última venda" */}
          {!filtros.apenasUltimaVenda && (
            <Col md={4}>
              <Form.Check
                type="checkbox"
                id="chk-cedente"
                label="Listar cedente de cessões do período"
                checked={filtros.listarCedente}
                onChange={(e) => setField(setFiltros, 'listarCedente', e.target.checked)}
              />
            </Col>
          )}
        </Row>
        <Row className="mb-1">
          <Col md={4}>
            <Form.Check
              type="checkbox"
              id="chk-detalhes"
              label="Apresentar detalhes do proprietário"
              checked={filtros.apresentarDetalhes}
              onChange={(e) => setField(setFiltros, 'apresentarDetalhes', e.target.checked)}
            />
          </Col>
          <Col md={4}>
            <Form.Check
              type="checkbox"
              id="chk-m2"
              label="Listar M² e endereço do lote"
              checked={filtros.listarM2Endereco}
              onChange={(e) => setField(setFiltros, 'listarM2Endereco', e.target.checked)}
            />
          </Col>
          <Col md={4}>
            <Form.Check
              type="checkbox"
              id="chk-codigo"
              label="Imprimir código do cliente"
              checked={filtros.imprimirCodigoCliente}
              onChange={(e) => setField(setFiltros, 'imprimirCodigoCliente', e.target.checked)}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Filtros;
